import Settings from 'Settings'

import {
  scriptHash as productionScriptHash,
  scriptText as productionScriptText
} from './forterProductionScript'
import {
  scriptHash as testingScriptHash,
  scriptText as testingScriptText
} from './forterTestingScript'

const getScriptTextAndHash = () =>
  Settings.get('REACT_APP_ENV') === 'production'
    ? {text: productionScriptText, hash: productionScriptHash}
    : {text: testingScriptText, hash: testingScriptHash}

let token: string
let isScriptAppended = false

export const initForter = () => {
  if (!isScriptAppended) {
    document.addEventListener('ftr:tokenReady', function (evt) {
      token = (evt as Event & {detail: string}).detail
    })

    const {text, hash} = getScriptTextAndHash()

    const script = document.createElement('script')
    script.setAttribute('type', 'text/javascript')
    script.setAttribute('id', '948e1f330455')
    script.setAttribute('script-src', hash)
    script.setAttribute('script-src-elem', hash)
    script.text = text

    document.body.appendChild(script)
    isScriptAppended = true
  }
}

export const getForterTokenObject = () =>
  token ? {fraudProtectionToken: token} : undefined
